import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { WithdrawalInteracAddPage } from './withdrawal-interac-add';
@NgModule({
    declarations: [
        WithdrawalInteracAddPage,
    ],
    imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule
    ],
})
export class WithdrawalInteracAddModule { }
